var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chapter hide",attrs:{"id":'chapter_' + _vm.chapter.chapterNumber}},[_c('div',{staticClass:"mx-5 my-3 content"})])}
var staticRenderFns = []

export { render, staticRenderFns }